"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const string_utils_1 = require("@/common/string_utils");
const material_ui_confirm_1 = require("material-ui-confirm");
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const _1 = require(".");
function default_1({ switchToQna }) {
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => state.whoAmI.is_logged_in);
    const leaderNick = (0, react_redux_1.useSelector)((state) => state.roomData.leader_nick);
    const companyInfo = (0, react_redux_1.useSelector)((state) => state.roomData.company_info);
    const hasCompanyInfo = !!companyInfo;
    const [expandCompanySellerInfo, setExpandCompanySellerInfo] = (0, react_1.useState)(false);
    const [showCompanyInfoDialog, setShowCompanyInfoDialog] = (0, react_1.useState)(false);
    const openCompanyInfoDialog = () => setShowCompanyInfoDialog(true);
    const closeCompanyInfoDialog = () => setShowCompanyInfoDialog(false);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const loginRequiredConfirm = () => {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('로그인이 필요한 서비스예요.'), (0, jsx_runtime_1.jsx)("br", {}), t('로그인하시겠어요?')] })),
            confirmationText: t('로그인'),
        })
            .then(() => (window.location.href = (0, string_utils_1.loginReturnPath)()))
            .catch(() => { });
    };
    const onCompanyInfoDetailClick = () => {
        if (!isLoggedIn)
            loginRequiredConfirm();
        else
            openCompanyInfoDialog();
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-table-row", css: { paddingBottom: '8px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '3px 16px',
                } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption3 gray-30" }, { children: hasCompanyInfo ? t('사업자 정보') : t('판매자 정보') })), (0, jsx_runtime_1.jsx)(svgs_1.ChevronDownSvg, { css: {
                            width: '16px',
                            height: '16px',
                            cursor: 'pointer',
                            'path:last-of-type': { fillOpacity: '0.2' },
                            transform: `rotate(${expandCompanySellerInfo ? 180 : 0}deg)`,
                        }, onClick: () => setExpandCompanySellerInfo(!expandCompanySellerInfo) })] })), (0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: expandCompanySellerInfo, timeout: 150 }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption3 gray-30", css: { padding: '10px 16px' }, translate: "no" }, { children: hasCompanyInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${t('상호명')}: ${companyInfo.company_name} | ${t('대표자명')}: ${companyInfo.company_president_name} | `, (0, jsx_runtime_1.jsx)("span", Object.assign({ css: { fontWeight: 'bold', textDecoration: 'underline', cursor: 'pointer' }, onClick: onCompanyInfoDetailClick }, { children: t('상세보기') })), (0, jsx_runtime_1.jsx)(_1.CompanyInfoDialog, { open: showCompanyInfoDialog, closeDialog: closeCompanyInfoDialog, switchToQna: switchToQna })] })) : (`${t('판매자명')}: ${leaderNick} | ${t('연락처')}: ${t('폰디 고객센터')} ${t('010-6535-1346')} | ${t('상품 교환/환불 문의는 판매자의 문의채널 또는 작품 문의해주세요')} :)`) })) }))] })));
}
exports.default = default_1;
